// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-location-select {
  /* Typography */
  --perxis-auto-location-select-font-family-inner: var(
    --perxis-auto-location-select-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-location-select-font-size-inner: var(
    --perxis-auto-location-select-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-location-select-font-weight-inner: var(
    --perxis-auto-location-select-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-location-select-letter-spacing-inner: var(
    --perxis-auto-location-select-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-location-select-line-height-inner: var(
    --perxis-auto-location-select-line-height,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --perxis-auto-location-select-text-transform-inner: var(
    --perxis-auto-location-select-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-location-select-text-decoration-line-inner: var(
    --perxis-auto-location-select-text-decoration-line,
    none
  );
  --perxis-auto-location-select-hover-text-decoration-line-inner: var(
    --perxis-auto-location-select-hover-text-decoration-line,
    var(--perxis-auto-location-select-text-decoration-line-inner)
  );
  --perxis-auto-location-select-active-text-decoration-line-inner: var(
    --perxis-auto-location-select-active-text-decoration-line,
    var(--perxis-auto-location-select-text-decoration-line-inner)
  );
  --perxis-auto-location-select-text-decoration-style-inner: var(
    --perxis-auto-location-select-text-decoration-style,
    initial
  );
  --perxis-auto-location-select-hover-text-decoration-style-inner: var(
    --perxis-auto-location-select-hover-text-decoration-style,
    var(--perxis-auto-location-select-text-decoration-style-inner)
  );
  --perxis-auto-location-select-active-text-decoration-style-inner: var(
    --perxis-auto-location-select-active-text-decoration-style,
    var(--perxis-auto-location-select-text-decoration-style-inner)
  );
  --perxis-auto-location-select-text-underline-offset-inner: var(
    --perxis-auto-location-select-text-underline-offset,
    auto
  );
  --perxis-auto-location-select-hover-text-underline-offset-inner: var(
    --perxis-auto-location-select-hover-text-underline-offset,
    var(--perxis-auto-location-select-text-underline-offset-inner)
  );
  --perxis-auto-location-select-active-text-underline-offset-inner: var(
    --perxis-auto-location-select-active-text-underline-offset,
    var(--perxis-auto-location-select-text-underline-offset-inner)
  );
  --perxis-auto-location-select-color-inner: var(
    --perxis-auto-location-select-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-location-select-hover-color-inner: var(
    --perxis-auto-location-select-hover-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* Icon color */
  --perxis-auto-location-select-icon-color-inner: var(
    --perxis-auto-location-select-icon-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-location-select-hover-icon-color-inner: var(
    --perxis-auto-location-select-hover-icon-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-location-select-active-icon-color-inner: var(
    --perxis-auto-location-select-active-icon-color,
    var(--perxis-auto-root-third-color-inner)
  );
  display: flex;
}
.perxis-auto-1_16_13-location-select.perxis-auto-1_16_13-location-select--open .perxis-auto-1_16_13-button.perxis-auto-1_16_13-button-text {
  --perxis-auto-button-text-icon-color: var(--perxis-auto-location-select-active-icon-color-inner);
  --perxis-auto-button-text-icon-color-hover: var(--perxis-auto-location-select-active-icon-color-inner);
  --perxis-auto-button-text-text-decoration-line: var(--perxis-auto-location-select-active-text-decoration-inner);
  --perxis-auto-button-text-decoration-style: var(--perxis-auto-location-select-active-text-decoration-style-inner);
  --perxis-auto-button-text-underline-offset: var(--perxis-auto-location-select-active-text-underline-offset-inner);
}
.perxis-auto-1_16_13-location-select .perxis-auto-1_16_13-button.perxis-auto-1_16_13-button-text {
  --perxis-auto-button-font-family-inner: var(--perxis-auto-location-select-font-family-inner);
  --perxis-auto-button-font-size-inner: var(--perxis-auto-location-select-font-size-inner);
  --perxis-auto-button-font-weight-inner: var(--perxis-auto-location-select-font-weight-inner);
  --perxis-auto-button-letter-spacing-inner: var(--perxis-auto-location-select-letter-spacing-inner);
  --perxis-auto-button-line-height-inner: var(--perxis-auto-location-select-line-height-inner);
  --perxis-auto-button-text-transform-inner: var(--perxis-auto-location-select-text-transform-inner);
  --perxis-auto-button-text-color: var(--perxis-auto-location-select-color-inner);
  --perxis-auto-button-text-hover-color: var(--perxis-auto-location-select-hover-color-inner);
  --perxis-auto-button-text-icon-color: var(--perxis-auto-location-select-icon-color-inner);
  --perxis-auto-button-text-icon-hover-color: var(--perxis-auto-location-select-hover-icon-color-inner);
  --perxis-auto-button-text-text-decoration-line: var(--perxis-auto-location-select-text-decoration-line-inner);
  --perxis-auto-button-text-hover-text-decoration-line: var(
    --perxis-auto-location-select-hover-text-decoration-line-inner
  );
  --perxis-auto-button-text-text-decoration-style: var(--perxis-auto-location-select-text-decoration-style-inner);
  --perxis-auto-button-text-hover-text-decoration-style: var(
    --perxis-auto-location-select-hover-text-decoration-style-inner
  );
  --perxis-auto-button-text-text-underline-offset: var(--perxis-auto-location-select-text-underline-offset-inner);
  --perxis-auto-button-text-hover-text-underline-offset: var(
    --perxis-auto-location-select-hover-text-underline-offset-inner
  );
}
.perxis-auto-1_16_13-location-select__popover.ant-5_17_0-popover {
  /* Typography */
  --perxis-auto-location-select-popover-font-family-inner: var(
    --perxis-auto-location-select-popover-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-location-select-popover-font-size-inner: var(
    --perxis-auto-location-select-popover-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-location-select-popover-font-weight-inner: var(
    --perxis-auto-location-select-popover-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-location-select-popover-letter-spacing-inner: var(
    --perxis-auto-location-select-popover-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-location-select-popover-line-height-inner: var(
    --perxis-auto-location-select-popover-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-location-select-popover-text-transform-inner: var(
    --perxis-auto-location-select-popover-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-location-select-popover-color-inner: var(
    --perxis-auto-location-select-popover-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-location-select-popover-background-color-inner: var(
    --perxis-auto-location-select-popover-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Z-index */
  --perxis-auto-location-select-popover-z-index-inner: var(--perxis-auto-location-select-popover-z-index, 1030);
  /* End Z-index */
  /* Padding */
  --perxis-auto-location-select-popover-padding-inner: var(--perxis-auto-location-select-popover-padding, 8px);
  /* End Padding */
  /* Border */
  --perxis-auto-location-select-popover-radius-inner: var(--perxis-auto-location-select-popover-radius, 8px);
  /* End Border */
  /* Shadows */
  --perxis-auto-location-select-box-shadow-inner: var(
    --perxis-auto-location-select-box-shadow,
    0px 0px 20px 0px #16161633
  );
  /* End Shadows */
  --antd-arrow-background-color: var(--perxis-auto-location-select-popover-background-color-inner);
  font-family: var(--perxis-auto-location-select-popover-font-family-inner);
  font-size: var(--perxis-auto-location-select-popover-font-size-inner);
  line-height: var(--perxis-auto-location-select-popover-line-height-inner);
  font-weight: var(--perxis-auto-location-select-popover-font-weight-inner);
  text-transform: var(--perxis-auto-location-select-popover-text-transform-inner);
  letter-spacing: var(--perxis-auto-location-select-popover-letter-spacing-inner);
  color: var(--perxis-auto-location-select-popover-color-inner);
  background-color: var(--perxis-auto-location-select-popover-background-color-inner);
  z-index: var(--perxis-auto-location-select-popover-z-index-inner);
  border-radius: var(--perxis-auto-location-select-popover-radius-inner);
}
.perxis-auto-1_16_13-location-select__popover.ant-5_17_0-popover .ant-5_17_0-popover-inner {
  background-color: var(--perxis-auto-location-select-popover-background-color-inner);
  padding: var(--perxis-auto-location-select-popover-padding-inner);
  padding-bottom: 0;
  border-radius: var(--perxis-auto-location-select-popover-radius-inner);
  box-shadow: var(--perxis-auto-location-select-box-shadow-inner);
  overflow: hidden;
}

.perxis-auto-1_16_13-location-list {
  /* Typography */
  --perxis-auto-location-list-title-font-family-inner: var(
    --perxis-auto-location-list-title-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-location-list-title-font-size-inner: var(
    --perxis-auto-location-list-title-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-location-list-title-font-weight-inner: var(--perxis-auto-location-list-title-font-weight, 600);
  --perxis-auto-location-list-title-letter-spacing-inner: var(
    --perxis-auto-location-list-title-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-location-list-title-line-height-inner: var(--perxis-auto-location-list-title-line-height, 1);
  --perxis-auto-location-list-title-text-transform-inner: var(
    --perxis-auto-location-list-title-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-location-list-title-color-inner: var(
    --perxis-auto-location-list-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-location-list-item-font-family-inner: var(
    --perxis-auto-location-list-item-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-location-list-item-font-size-inner: var(
    --perxis-auto-location-list-item-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-location-list-item-font-weight-inner: var(
    --perxis-auto-location-list-item-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-location-list-item-selected-font-weight-inner: var(
    --perxis-auto-location-list-item-selected-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-location-list-item-letter-spacing-inner: var(
    --perxis-auto-location-list-item-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-location-list-item-line-height-inner: var(--perxis-auto-location-list-item-line-height, 1);
  --perxis-auto-location-list-item-text-transform-inner: var(
    --perxis-auto-location-list-item-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-location-list-item-color-inner: var(
    --perxis-auto-location-list-item-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-location-list-item-hover-color-inner: var(
    --perxis-auto-location-list-item-hover-color,
    var(--perxis-auto-location-list-item-color-inner)
  );
  --perxis-auto-location-list-item-selected-color-inner: var(
    --perxis-auto-location-list-item-selected-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-location-list-item-selected-hover-color-inner: var(
    --perxis-auto-location-list-item-selected-hover-color,
    var(--perxis-auto-location-list-item-selected-color-inner)
  );
  --perxis-auto-location-list-item-decoration-inner: var(--perxis-auto-location-list-item-decoration, none);
  --perxis-auto-location-list-item-hover-decoration-inner: var(
    --perxis-auto-location-list-item-hover-decoration,
    var(--perxis-auto-location-list-item-decoration-inner)
  );
  --perxis-auto-location-list-item-coincidence-font-weight-inner: var(
    --perxis-auto-location-list-item-coincidence-font-weight,
    700
  );
  /* End Typography */
  /* Geometry */
  --perxis-auto-location-list-max-height-inner: var(--perxis-auto-location-list-max-height, 190px);
  --perxis-auto-location-list-width-inner: var(--perxis-auto-location-list-width, 284px);
  /* List item text ellipsis or wrap */
  --perxis-auto-location-list-item-white-space-inner: var(--perxis-auto-location-list-item-white-space, nowrap);
  /* Margin */
  --perxis-auto-location-list-margin-inner: var(
    --perxis-auto-location-list-margin,
    0 calc(var(--perxis-auto-location-select-popover-padding-inner) * -1)
  );
  /* End Margin */
  /* Padding */
  --perxis-auto-location-list-padding-inner: var(--perxis-auto-location-list-padding, 0);
  --perxis-auto-location-list-item-padding-inner: var(--perxis-auto-location-list-item-padding, 12px 18px);
  /* End Padding */
  /* Scrollbar */
  --perxis-auto-location-list-scrollbar-width-inner: var(--perxis-auto-location-list-scrollbar-width, 8px);
  --perxis-auto-location-list-scrollbar-height-inner: var(
    --perxis-auto-location-list-scrollbar-height,
    var(--perxis-auto-location-list-scrollbar-width-inner)
  );
  --perxis-auto-location-list-scrollbar-track-background-color-inner: var(
    --perxis-auto-location-list-scrollbar-track-background-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-location-list-scrollbar-thumb-background-color-inner: var(
    --perxis-auto-location-list-scrollbar-thumb-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-location-list-scrollbar-thumb-border-radius-inner: var(
    --perxis-auto-location-list-scrollbar-thumb-border-radius,
    5px
  );
  /* End Scrollbar */
  --perxis-auto-location-list-error-font-family-inner: var(
    --perxis-auto-location-list-error-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-location-list-error-line-height-inner: var(
    --perxis-auto-location-list-error-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-location-list-error-font-size-inner: var(
    --perxis-auto-location-list-error-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-location-list-error-font-weight-inner: var(
    --perxis-auto-location-list-error-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-location-list-error-letter-spacing-inner: var(
    --perxis-auto-location-list-error-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-location-list-error-text-transform-inner: var(
    --perxis-auto-location-list-error-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-location-list-error-color-inner: var(
    --perxis-auto-location-list-error-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  --perxis-auto-location-list-error-padding-inner: var(--perxis-auto-location-list-error-padding, 12px 10px 4px 10px);
  /* Colors */
  --perxis-auto-location-list-item-background-color-inner: var(
    --perxis-auto-location-list-item-background-color,
    transparent
  );
  --perxis-auto-location-list-item-hover-background-color-inner: var(
    --perxis-auto-location-list-item-hover-background-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-location-list-item-selected-hover-background-color-inner: var(
    --perxis-auto-location-list-item-selected-hover-background-color,
    var(--perxis-auto-location-list-item-hover-background-color-inner)
  );
  --perxis-auto-location-list-item-selected-background-color-inner: var(
    --perxis-auto-location-list-item-selected-background-color,
    transparent
  );
  --perxis-auto-location-list-search-placeholder-color-inner: var(
    --perxis-auto-location-list-search-placeholder-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-location-list-search-placeholder-font-size-inner: var(
    --perxis-auto-location-list-search-placeholder-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  /* End Colors */
  width: var(--perxis-auto-location-list-width-inner);
}
.perxis-auto-1_16_13-location-list__title {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-location-list-title-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-location-list-title-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-location-list-title-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-location-list-title-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-location-list-title-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-location-list-title-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-location-list-title-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-location-list-title-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-location-list-title-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-location-list-title-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-location-list-title-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-location-list-title-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-location-list-title-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-location-list-title-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-location-list-title-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-location-list-title-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-location-list-title-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-location-list-title-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-location-list-title-line-height-inner);
}
.perxis-auto-1_16_13-location-list__search {
  --perxis-auto-input-placeholder-font-size: var(--perxis-auto-location-list-search-placeholder-font-size-inner);
  --perxis-auto-input-placeholder-color: var(--perxis-auto-location-list-search-placeholder-color-inner);
}
.perxis-auto-1_16_13-location-list__error {
  padding: var(--perxis-auto-location-list-error-padding-inner);
  --perxis-auto-typography-small-font-family: var(--perxis-auto-location-list-error-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-location-list-error-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-location-list-error-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-location-list-error-text-transform-inner);
  --perxis-auto-typography-color-light-colorful: var(--perxis-auto-location-list-error-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-location-list-error-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-location-list-error-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-location-list-error-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-location-list-error-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-location-list-error-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-location-list-error-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-location-list-error-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-location-list-error-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-location-list-error-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-location-list-error-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-location-list-error-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-location-list-error-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-location-list-error-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-location-list-error-line-height-inner);
}
.perxis-auto-1_16_13-location-list__list {
  display: grid;
  overflow: auto;
  max-height: var(--perxis-auto-location-list-max-height-inner);
  list-style: none;
  padding: var(--perxis-auto-location-list-padding-inner);
  margin: var(--perxis-auto-location-list-margin-inner);
  scrollbar-color: var(--perxis-auto-location-list-scrollbar-thumb-background-color-inner);
}
.perxis-auto-1_16_13-location-list__list::-webkit-scrollbar {
  height: var(--perxis-auto-location-list-scrollbar-height-inner);
  width: var(--perxis-auto-location-list-scrollbar-width-inner);
}
.perxis-auto-1_16_13-location-list__list::-webkit-scrollbar-track {
  background: var(--perxis-auto-location-list-scrollbar-track-background-color-inner);
}
.perxis-auto-1_16_13-location-list__list::-webkit-scrollbar-thumb {
  background-color: var(--perxis-auto-location-list-scrollbar-thumb-background-color-inner);
  border-radius: var(--perxis-auto-location-list-scrollbar-thumb-border-radius-inner);
}
.perxis-auto-1_16_13-location-list__list-item {
  display: block;
  cursor: pointer;
  padding: var(--perxis-auto-location-list-item-padding-inner);
  background-color: var(--perxis-auto-location-list-item-background-color-inner);
  --perxis-auto-typography-small-font-family: var(--perxis-auto-location-list-item-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-location-list-item-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-location-list-item-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-location-list-item-text-transform-inner);
  --perxis-auto-typography-link-color: var(--perxis-auto-location-list-item-color-inner);
  --perxis-auto-typography-link-hover-color: var(--perxis-auto-location-list-item-hover-color-inner);
  --perxis-auto-typography-link-decoration: var(--perxis-auto-location-list-item-decoration-inner);
  --perxis-auto-typography-link-hover-decoration: var(--perxis-auto-location-list-item-hover-decoration-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-location-list-item-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-location-list-item-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-location-list-item-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-location-list-item-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-location-list-item-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-location-list-item-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-location-list-item-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-location-list-item-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-location-list-item-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-location-list-item-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-location-list-item-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-location-list-item-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-location-list-item-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-location-list-item-line-height-inner);
}
.perxis-auto-1_16_13-location-list__list-item .perxis-auto-1_16_13-typography {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: var(--perxis-auto-location-list-item-white-space-inner);
  user-select: none;
}
.perxis-auto-1_16_13-location-list__list-item .perxis-auto-1_16_13-typography .perxis-auto-1_16_13-typography {
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-location-list-item-coincidence-font-weight-inner);
}
.perxis-auto-1_16_13-location-list__list-item:hover {
  background-color: var(--perxis-auto-location-list-item-hover-background-color-inner);
}
.perxis-auto-1_16_13-location-list__list-item:hover .perxis-auto-1_16_13-typography {
  color: var(--perxis-auto-location-list-item-hover-color-inner) !important;
}
.perxis-auto-1_16_13-location-list__list-item-selected {
  background-color: var(--perxis-auto-location-list-item-selected-background-color-inner);
  --perxis-auto-typography-link-color: var(--perxis-auto-location-list-item-selected-color-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-location-list-item-selected-font-weight-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-location-list-item-selected-color-inner);
}
.perxis-auto-1_16_13-location-list__list-item-selected:hover {
  background-color: var(--perxis-auto-location-list-item-selected-hover-background-color-inner);
}
.perxis-auto-1_16_13-location-list__list-item-selected:hover .perxis-auto-1_16_13-typography {
  color: var(--perxis-auto-location-list-item-selected-hover-color-inner) !important;
}

/* LocationSelect skeleton*/
.perxis-auto-1_16_13-location-select-skeleton {
  /* Icon margins */
  --perxis-auto-location-select-skeleton-icon-margins-inner: var(
    --perxis-auto-location-select-skeleton-icon-margins,
    0 10px 8px
  );
  display: flex;
}
.perxis-auto-1_16_13-location-select-skeleton .ant-5_17_0-skeleton-avatar {
  margin: var(--perxis-auto-location-select-skeleton-icon-margins-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
